export const onServiceWorkerUpdateReady = () => {
  const answer = window.confirm(
    `ページが更新されました. ` +
      `リロードしますか?`
  )

  if (answer === true) {
    window.location.reload()
  }
}